export function tableSelectFilter (list) {
    let array = []
    list.map((item) => {
        let obj = {
            text:'',
            value:''
        };
        obj['text'] = item
        obj['value'] = item
        array.push(obj)
    })
    return array;
}
